import React, { useState, useEffect } from 'react';
import { BACKEND_URL } from '../config';
import { motion } from 'motion/react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LegalDocumentRenderer from '../components/LegalDocumentRenderer';

import {
  Shield
} from '@phosphor-icons/react';
const Privacy = () => {
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDocument();
  }, []);

  const fetchDocument = async () => {
    try {
      const response = await fetch(
        `${BACKEND_URL}/api/legal/privacy`
      );

      if (response.ok) {
        const data = await response.json();
        setDocument(data);
      }
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
    } finally {
      setLoading(false);
    }
  };

  const springConfig = {
    type: 'spring',
    damping: 80,
    stiffness: 400,
    mass: 1,
  };

  return (
    <div className="bg-[#161B26]">
      <SEO 
        title="Privacy Policy - Man & Machine"
        description="Learn how we protect and handle your personal information."
        canonicalUrl="https://manmachine.agency/privacy"
      />
      <Header />

      {/* Hero Section - Compact */}
      <section className="pt-24 pb-12 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#6366F1] rounded-full filter blur-3xl opacity-20"></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={springConfig}
            className="text-center max-w-4xl mx-auto"
          >
            <div className="inline-flex p-3 rounded-xl bg-gradient-to-br from-[#6366F1]/20 to-[#EC4899]/20 mb-4">
              <Shield size={32} className="text-[#6366F1]" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">
              {document?.title || 'Privacy Policy'}
            </h1>
            {document?.last_updated && (
              <p className="text-sm text-[#A0AEC0]">
                Last updated: {new Date(document.last_updated).toLocaleDateString('en-US', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </p>
            )}
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="pb-20 bg-[#161B26]">
        <div className="max-w-4xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...springConfig, delay: 0.1 }}
          >
            <div className="glass rounded-3xl p-8 md:p-12">
              {loading ? (
                <div className="text-center py-12 text-[#A0AEC0]">
                  Loading...
                </div>
              ) : !document ? (
                <div className="text-center py-12 text-[#A0AEC0]">
                  <p>Privacy Policy not available at the moment.</p>
                  <p className="mt-2 text-sm">Please contact us for more information.</p>
                </div>
              ) : (
                <LegalDocumentRenderer content={document.content} skipTitle={true} />
              )}
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Privacy;